<script setup lang="ts">
const cart = useCartStore();
const { t } = useI18n();

const item = toRef(cart, 'addOrderNotificationItem');
const img = computed(() => {
  return `${item.value.folder}${item.value.photos[0]}`;
});

const checkout = () => {
  cart.addOrderNotificationItem = null;
  navigateTo('/cart');
};

const continueShoping = () => {
  cart.addOrderNotificationItem = null;
};
</script>

<template>
  <Teleport
    v-if="!!item"
    to="#teleports"
  >
    <div class="absolute z-50 w-full h-full flex items-center justify-center  bg-gray-800/50 text-gray-950 pointer-events-auto">
      <div class="relative p-8 rounded-big bg-gray-100 flex gap-4 items-start justify-center text-gray-900">
        <CloseButton
          size="big"
          class="absolute top-2 right-2"
          @click="continueShoping"
        />
        <NuxtImg
          format="webp"
          provider="digitalocean"
          :src="img"
          :alt="item.title"
          class="rounded-big"
          width="252"
        />
        <div class="flex flex-col gap-4">
          <div class="text-h3 font-dedicated">
            {{ t('Item_added_to_cart') }}
          </div>
          <div class="text-big">
            {{ t(item.type) }}
          </div>
          <div class="text-big font-dedicated">
            {{ convertPriceToEuroString(item.price) }}
          </div>
          <div class="flex flex-col gap-2">
            <ButtonLevel
              type="2"
              class="w-full"
              :title="t('Proceed_to_Checkout')"
              @click="checkout"
            />
            <ButtonLevel
              type="3"
              :title="t('Continue_Shopping')"
              class="w-full"
              @click="continueShoping"
            />
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<style scoped>

</style>
